/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiSeasonTableSeasonIdGet200Response } from '../models';
/**
 * SeasonTableApi - axios parameter creator
 * @export
 */
export const SeasonTableApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get league table by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSeasonTableSeasonIdGet: async (seasonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('apiSeasonTableSeasonIdGet', 'seasonId', seasonId)
            const localVarPath = `/api/season-table/{season_id}`
                .replace(`{${"season_id"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeasonTableApi - functional programming interface
 * @export
 */
export const SeasonTableApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeasonTableApiAxiosParamCreator(configuration)
    return {
        /**
         * Get league table by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSeasonTableSeasonIdGet(seasonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSeasonTableSeasonIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSeasonTableSeasonIdGet(seasonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeasonTableApi.apiSeasonTableSeasonIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SeasonTableApi - factory interface
 * @export
 */
export const SeasonTableApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeasonTableApiFp(configuration)
    return {
        /**
         * Get league table by id from Sportradar API
         * @param {SeasonTableApiApiSeasonTableSeasonIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSeasonTableSeasonIdGet(requestParameters: SeasonTableApiApiSeasonTableSeasonIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiSeasonTableSeasonIdGet200Response> {
            return localVarFp.apiSeasonTableSeasonIdGet(requestParameters.seasonId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiSeasonTableSeasonIdGet operation in SeasonTableApi.
 * @export
 * @interface SeasonTableApiApiSeasonTableSeasonIdGetRequest
 */
export interface SeasonTableApiApiSeasonTableSeasonIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SeasonTableApiApiSeasonTableSeasonIdGet
     */
    readonly seasonId: string
}

/**
 * SeasonTableApi - object-oriented interface
 * @export
 * @class SeasonTableApi
 * @extends {BaseAPI}
 */
export class SeasonTableApi extends BaseAPI {
    /**
     * Get league table by id from Sportradar API
     * @param {SeasonTableApiApiSeasonTableSeasonIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonTableApi
     */
    public apiSeasonTableSeasonIdGet(requestParameters: SeasonTableApiApiSeasonTableSeasonIdGetRequest, options?: RawAxiosRequestConfig) {
        return SeasonTableApiFp(this.configuration).apiSeasonTableSeasonIdGet(requestParameters.seasonId, options).then((request) => request(this.axios, this.basePath));
    }
}

